import React, { FC } from 'react';
import type { InvestorAppreciationProps } from '@/types';
import { TextCols } from '../text-cols';

export const InvestorAppreciation: FC<InvestorAppreciationProps> = ({ cols }) => {
  return (
    <section className="investorAppreciation">
      <div className="wrapper">
        <TextCols content={cols} />
      </div>
    </section>
  );
};
